import { ApiStatus } from "./types";

export function snooze(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function _translateStatusCode(statusCode: number): ApiStatus {
  if (statusCode === 200 || statusCode === 201) {
    return ApiStatus.Success;
  } else if (statusCode === 404) {
    return ApiStatus.NotPresent;
  } else if (statusCode === 409) {
    return ApiStatus.DuplicateOrConflict;
  } else if (statusCode === 422) {
    return ApiStatus.Validation;
  } else {
    return ApiStatus.Unknown;
  }
}

export function timeout<T>(ms: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("TIMEOUT"));
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });
}
